// extracted by mini-css-extract-plugin
export var avatar = "CompetitorAvatar-module--avatar--d3617";
export var blank = "CompetitorAvatar-module--blank--5983d";
export var fallback = "CompetitorAvatar-module--fallback--3039c";
export var flag = "CompetitorAvatar-module--flag--78265";